export const FEATURES = {
  // Homepage
  DAILY_CHECKIN: false,

  // Header
  REWARD_SHOP: false,
  COINS: false,

  // Profile
  PROFILE_21DAY_GIFT: false,
  PROFILE_READER_TASKS: false,
  PROFILE_PURCHASED: false,
};
